var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-header"},[(_vm.ui && _vm.ui.openAddCart)?_c('modal-cross-sell',{on:{"open":_vm.open}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }